<template>
  <v-row>
    <div :style="{
        height: '40px',
        width: '5px',
        backgroundColor: color,
        margin: '10px 0'
      }" />
    <v-col>
      <v-row>
        <v-col cols="2">
          <v-text-field
            v-model="value.name"
            :label="$t('common.name')"
            dense
            outlined
            @change="validate.name.$touch()"
            @input="$emit('input', value)"
            :error-messages="[...errorMessages('name'), nameError].filter(i => !!i)"
            :disabled="disabled"
          />
        </v-col>
        <v-col cols="3">
          <vf-date-input
            v-model="value.originalDate"
            :label="$t('payment.milestone.date')"
            outlined
            dense
            :disabled="disabled"
            @input="handlePickerChange"
            @change="validate.originalDate.$touch()"
            :error-messages="errorMessages('originalDate')"
          />
        </v-col>
        <v-col cols="3">
          <vf-currency-input
            v-model="value.paymentAmountCents"
            :currency="{ key: value.currency.key || value.currency, value: 1 }"
            :label="$t('payment.milestone.payment')"
            dense
            outlined
            :disabled="disabled || hasVariation"
            @input="handleAmountChange"
            @change="validate.paymentAmountCents.$touch()"
            :error-messages="[...errorMessages('paymentAmountCents'), amountError].filter(i => !!i)"
          />
        </v-col>
        <v-col>
          <PartsSelect
            v-model="value.part"
            :parts="parts"
            :disabled="disabled || hasVariation"
            :isMultiCurrency="isMultiCurrency"
            @input="handlePartChange"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { errorMessageGenerator } from '@/validators'

export default {
  name: 'SubMilestoneValueRow',
  props: {
    value: Object,
    color: String,
    validate: Object,
    nameDuplicateError: Function,
    parts: Array,
    editMode: Boolean,
    isMultiCurrency: Boolean
  },
  data () {
    return {
      originalDateMenu: false,
      amountError: null,
      key: 0
    }
  },
  computed: {
    nameError () {
      return this.nameDuplicateError(this.value.name)
    },
    paymentAmountCents () {
      return this.value.paymentAmountCents
    },
    hasVariation () {
      return !!this.value.variationId
    },
    disabled () {
      return isNaN(this.value.amountAssignedToApplication)
        ? !!this.value.amountAssignedToApplication.sum
        : !!this.value.amountAssignedToApplication
    }
  },
  methods: {
    handlePartChange () {
      this.$emit('input', this.value)
    },
    handleAmountChange () {
      this.validate.paymentAmountCents.$touch()
      this.$emit('input', this.value)
    },
    handlePickerChange () {
      this.originalDateMenu = false
      this.value.forecastedDate = this.value.originalDate
      this.$emit('input', this.value)
    },
    errorMessages (key) {
      return errorMessageGenerator(this.validate[key], key)
    }
  },
  watch: {
    'value.paymentAmountCents' (v, p) {
      const remainingValue = this.value.part.remainingValue + this.value.originalPaymentAmountCents
      this.amountError = v > remainingValue ? this.$t('payment.milestone.amountHigherThanPartRemainingValueError') : null
      this.$emit('set-error', !!this.amountError)
    }
  }
}
</script>
